import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  injectNgControl,
  NoopValueAccessorDirective,
} from '../../../directives/form/noop-value-accessor';
import { ImmomioIconName } from '@resident-nx/shared';
import { CardWebComponent, IconWebComponent } from '@resident-nx/web/ui';
import { ControlErrorContainerDirective } from '../../../directives/form/form-control-error-container.directive';
import { FormFieldComponent } from '../form/form-field.component';
import { FormControlErrorsDirective } from '../../../directives/form/form-control-errors.directive';

@Component({
  standalone: true,
  selector: 'rs-web-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    IconWebComponent,
    CardWebComponent,
    ControlErrorContainerDirective,
    FormControlErrorsDirective,
    FormFieldComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [NoopValueAccessorDirective],
})
export class PasswordComponent {
  public passwordControl = injectNgControl();
  public showPasswordAsText = signal(false);
  public hideValidatorBox = input(false);
  public isConfirmPassword = input(false);

  public validatorContexts: Array<{ name: string; text: string }> = [
    { name: 'minLength', text: 'password.min_8_characters_l' },
    {
      name: 'hasLowerUpperCase',
      text: 'password.capital_and_lower_case_char_l',
    },
    { name: 'hasNumberSpecial', text: 'pw-check.error.pw-has_number_special' },
  ];
  protected readonly ImmomioIconName = ImmomioIconName;
}
